export function trackEvent(eventName, payload = {}) {
  const eventData = {
    event: eventName,
    payload,
    timestamp: new Date().toISOString(),
  };

  // 1. Console log in dev
  if (import.meta.env.DEV) {
    console.log('[Analytics Event]:', eventData);
  }

  // 2. Window dataLayer / gtag push if present
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(eventData);
  }

  // 3. LocalStorage event queue backup
  try {
    const queue = JSON.parse(localStorage.getItem('gradelynk_analytics_events') || '[]');
    queue.push(eventData);
    if (queue.length > 50) queue.shift();
    localStorage.setItem('gradelynk_analytics_events', JSON.stringify(queue));
  } catch {
    // fallback
  }
}
